{
  "common": {
    "accountName": "Account Name",
    "admin": "Admin",
    "callsign": "Callsign",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "confirmPassword": "Confirm Password",
    "createAccount": "Create Account",
    "delete": "Delete",
    "deleted": "Deleted",
    "developing": "Developing",
    "devDebug": "Dev Debug",
    "documentation": "Documentation",
    "download": "Download",
    "edit": "Edit",
    "email": "Email",
    "emailErrorRequiredLabel": "Enter email.",
    "emailErrorEmailFormatLabel": "Please enter a valid email address.",
    "experimental": "Experimental",
    "failed": "Failed",
    "firstName": "First Name",
    "invite": "Invite",
    "invitation": "Invitation",
    "invitations": "Invitations",
    "invitationCode": "Invitation Code",
    "highlight": "Highlight",
    "lastName": "Last Name",
    "mapEditor": "Map Editor",
    "modified": "Modified",
    "more": "More",
    "name": "Name",
    "newProject": "New {{common.project}}",
    "operations": "Operations",
    "environment": "Environment",
    "robotMaps": "Robot Maps",
    "open": "Open",
    "organizationName": "Organization Name",
    "password": "Password",
    "pleaseEnter": "Please enter {{field}}.",
    "project": "Project",
    "projects": "Projects",
    "publish": "Publish",
    "reportABug": "Report a Bug",
    "requiredLabel": "Required",
    "resetPassword": "Reset Password",
    "robot": "Robot",
    "robotCallsign": "{{common.robot}} {{common.callsign}}",
    "robotDefinitions": "Robot Profiles",
    "robots": "Robots",
    "save": "Save",
    "sendEmail": "Send Email",
    "signIn": "Sign In",
    "signOut": "Sign Out",
    "signUp": "Sign Up",
    "size": "Size",
    "settings": "Settings",
    "storageExplorer": "Storage Explorer",
    "storageQuery": "Storage Query",
    "storageStreams": "Storage Streams",
    "exportButton": "Export",
    "automate": "Automate"
  },
  "core": {
    "comfirmDialog": {
      "doYouWantToContinue": "Do you want continue?"
    },
    "projectCard": {
      "deleteProject": "{{common.delete}} {{common.project}}",
      "deleteWarning": "Warning! The action you are about to take cannot be undone. Continuing will permanently delete this Project including all its related resources and stored data.",
      "deleteConfirm": "Please confirm by typing in the Project Name",
      "invitePeople": "{{common.invite}} People",
      "inviteSent": "{{common.invite}} Sent.",
      "projectUpdated": "{{common.project}} updated."
    },
    "login": {
      "forgotPasswordButtonLabel": "Forgot password?",
      "passwordErrorRequiredLabel": "Enter password."
    },
    "navBar": {
      "adminOnlyHide": "{{common.admin}} Only (Hide)",
      "adminOnlyShow": "{{common.admin}} Only (Show)",
      "developingHide": "{{common.developing}} (Hide)",
      "developingShow": "{{common.developing}} (Show)",
      "experimentalHide": "{{common.experimental}} (Hide)",
      "experimentalShow": "{{common.experimental}} (Show)",
      "highlightEnable": "{{common.highlight}} (Enable)",
      "highlightDisable": "{{common.highlight}} (Disable)"
    },
    "resetPassword": {
      "description": "Please enter your email address. We will send you an email to reset your password."
    },
    "signUp": {
      "accountNameLabel": "Account Name",
      "ackownledgementMessage": "By signing up you are agreeing to ROCOS’ <a href=\"https://www.dronedeploy.com/legal/master-services-agreement/\">Terms of Use</a> and <a href=\"https://content.rocos.io/privacy.html\">Privacy Policy</a>.",
      "confirmYourPassword": "Confirm your password.",
      "emailHasBeenTakenErrorLabel": "That email is taken. Try another.",
      "nameIncorrectErrorLabel": "Are you sure you’ve entered your name correctly?",
      "passwordRequiredErrorLabel": "Please enter a password.",
      "passwordStrengthErrorLabel": "Please choose a stronger password. Use 8 or more characters with a mix of uppercase letters, lowercase letters, numbers & symbols. Use 12 or more characters when symbols cannot be used.",
      "passwordStrengthHintLabel": "Use eight or more characters with a mix of uppercase letters, lowercase letters, numbers & symbols. Use 12 or more characters when symbols cannot be used.",
      "signInInsteadButtonLabel": "Sign In Instead"
    }
  },
  "mapEditor": {
    "eraser": "Eraser",
    "exportPGM": "Export PGM",
    "exportPGMTooltip": "Export to PGM file",
    "exportYaml": "Export YAML",
    "exportYamlTooltip": "Export to YAML file",
    "importPGM": "Import PGM",
    "importPGMTooltip": "Upload PGM file",
    "importYaml": "Import YAML",
    "importYamlTooltip": "Upload YAML file",
    "openPGMFromRobot": "Open PGM From Robot",
    "openPGMFromRobotDialogTitle": "{{mapEditor.openPGMFromRobot}}",
    "openPGMFromRobotTooltip": "Open PGM from robot",
    "savePGMToRobot": "Save PGM To Robot",
    "savePGMToRobotDialogTitle": "{{mapEditor.savePGMToRobot}}",
    "savePGMToRobotTooltip": "Save PGM to robot",
    "openYamlFromRobot": "Open YAML From Robot",
    "openYamlFromRobotDialogTitle": "{{mapEditor.openYamlFromRobot}}",
    "openYamlFromRobotTooltip": "Open YAML from robot",
    "saveYamlToRobot": "Save YAML To Robot",
    "saveYamlToRobotDialogTitle": "{{mapEditor.saveYamlToRobot}}",
    "saveYamlToRobotTooltip": "Save YAML to robot",
    "pencil": "Pencil",
    "straightLine": "Straight Line"
  },
  "fileExplorer": {
    "emptyFolderMessage": "This folder is empty.",
    "fileName": "File Name",
    "pluginNotAvailbaleMessage": "The File Transfer plugin is not enabled. Please enable it via the agent settings.",
    "newFolder": "New Folder",
    "uploadFile": "Upload File"
  }
}
